import { cn } from '@/lib/utils';

/**
 * Director TMS brand mark + "powered by 3MZ Solutions" (Martin #40). The logos
 * are dark wordmarks, so they sit on a white pill to stay legible on the dark
 * app background. Drop the assets at:
 *   pwa/public/brand/director-tms.png
 *   pwa/public/brand/3mz-solutions.png
 */
export function BrandFooter({ className }: { className?: string }) {
  return (
    <div className={cn('flex flex-col items-center', className)}>
      <div className="flex flex-col items-center gap-1 rounded-lg bg-white px-5 py-3 shadow-md">
        <img src="/brand/director-tms.png" alt="Director TMS" className="h-9 w-auto" />
        <div className="flex items-center gap-1 text-[10px] text-gray-500">
          <span>powered by</span>
          <img src="/brand/3mz-solutions.png" alt="3MZ Solutions" className="h-3 w-auto" />
        </div>
      </div>
    </div>
  );
}
